import { HttpEvent, HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "@environments/environment";
import { inject } from "@angular/core";
import { AuthService } from "@core/services/auth.service";
import { SKIP_INTERCEPTORS } from "@shared/constants/http-context-tokens";

export function accessKeyHeaderInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  if (req.context.get(SKIP_INTERCEPTORS)) {
    return next(req);
  }

  const contextToken = inject(AuthService).getAuthToken();

  const request = req.clone({
    setHeaders: {
      "sw-access-key": environment.shopwareApiKey,
      "sw-context-token": contextToken ?? "",
    },
  });

  return next(request);
}
